import { VatCode } from '../../../types/VatCode';
import { formatPrice } from '../../../utils/functions/data.functions';
import { TableColumn } from '../../table/DataTable.types';

export const columns = (vatCodes: VatCode[]) =>
  [
    {
      accessor: 'name',
      name: 'page.code-book-item.col-name',
    },
    {
      accessor: 'code',
      name: 'page.code-book-item.col-code',
    },
    {
      accessor: 'vatCodeId',
      name: 'page.code-book-item.col-vat-code',
      cellRenderer(e) {
        const vatCode = vatCodes.find((x: VatCode) => x.id === e.vatCodeId);
        return (
          <span>{vatCode ? vatCode?.code + ': ' + vatCode?.coefficientPercent + '%' : ''}</span>
        );
      },
    },
    {
      accessor: 'price',
      name: 'page.code-book-item.col-price',
      className: `text-right ml-auto`,
      cellRenderer(e) {
        return <span>{formatPrice(e.price)}</span>;
      },
    },
    {
      accessor: 'unit',
      name: 'page.code-book-item.col-unit',
    },
  ] as TableColumn[];
